import { render, staticRenderFns } from "./Unicard.vue?vue&type=template&id=3e9180f8&"
import script from "./Unicard.vue?vue&type=script&lang=js&"
export * from "./Unicard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports